@if (donneesChargees()) {
  <div id="donnee_analyse_content">
    <!-- <h5>{{typeParent() === TypeParent.Projet ? ('GLOBAL.PROJET' | translate) : (typeParent() === TypeParent.Tir ?
  ('GLOBAL.TIR' | translate) : ('GLOBAL.NOEUD' | translate)) }}</h5> -->
  <app-grid-list-kpi [listeObjets]="tabConfigSaisie()" [tabDonneesAnalyse]="tabDonneesAnalyse()" [configeView]="false"
    [isGuest]="estClient()" [estProjet]="estProjet()" [estTir]="estTir()" [siteCurrency]="siteCurrency()" [inProjetDetail]="inProjetDetail()" [tirId]="tirId()">
  </app-grid-list-kpi>
  <hr class="mt-4 mb-4">
  @if (!tabDonneesAnalyse() || tabDonneesAnalyse().length == 0) {
    <p>{{'DONNEE_ANALYSE.AUCUNE_DONNEE' | translate}}</p>
  }
  @if (typeParent() === TypeParent.Projet) {
    <button type="button" class="btn btn-primary" (click)="lancerExport()">
      <i class="fas fa-file-csv" style="padding-right:5px"></i>{{'GLOBAL.EXPORTER' | translate}} csv
    </button>
  }
</div>
}

<div bsModal #modalExport="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name"
  [config]="{backdrop: 'static', keyboard:false}">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left not-selectable">{{'GLOBAL.EXPORT_DONNEES' | translate}}</h4>
      </div>
      <div class="modal-body">
        <div class="not-selectable" [ngClass]="aucuneDonnee() ? '' :'text-center'">{{aucuneDonnee() ?
        ('GLOBAL.AUCUNE_DONNEE_EXPORT' | translate) : ('GLOBAL.PREPARATION_EXPORT' | translate)}}</div>
        @if (aucuneDonnee()) {
          <div class="btn-toolbar justify-content-end">
            <button type="button" class="btn btn-secondary" (click)="modalExport.hide()">{{'GLOBAL.FERMER' |
            translate}}</button>
          </div>
        }
      </div>
    </div>
  </div>
</div>